import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { DownloadAttachment } from "../../Actions/AttachmentAPI";
import { Translation } from "react-i18next";
import AddIcon from "../../UIComponents/AddIcon";
import { withRouter } from "react-router-dom";
import { getMakeSearchList } from "../../Actions/lookupAPI";
import axios from "axios";
import API from "../../helpers/api";
import { postModalAttachment, deleteAttachmentInBucket } from "../../Actions/CommonAPI";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import { confirmAlert } from "react-confirm-alert";
import i18n from "../DropdownLanguage/i18n";
import { OverlayTrigger, Popover } from "react-bootstrap";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
  Make: "",
  Model: "",
  PageNumber: 1,
  PageSize: 20,
};
var fileDatas = [];
class MakeEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MakeModelDetails: {
        makeId: 0,
        make: "",
        modelList: [],
      },
      models: [],
      ModelDetails: {
        modelId: 0,
        Id: 0,
        modelName: "",
        attachmentName: "",
        attachmentGuid: "",
      },
      file: "",
      fileName: "",
      DeleteModel: [],
      modalIsOpen: false,
      isModelNew: true,
    };
    this.UpdateMakeModel = this.UpdateMakeModel.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.ClearModel = this.ClearModel.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { ModalAttachment, MakeDetail, dispatch } = nextProps;
    if (MakeDetail && MakeDetail !== "") {
      prevState.MakeModelDetails.makeId = MakeDetail?.makeId;
      prevState.MakeModelDetails.make = MakeDetail?.makeName;
      prevState.MakeModelDetails.modelList = MakeDetail?.modelList;
      prevState.models = MakeDetail?.modelList;
      dispatch({ type: "MakeDetailsSuccess", data: "" });
    }
    if (ModalAttachment) {
      prevState.ModelDetails.attachmentName = ModalAttachment.FileName;
      prevState.ModelDetails.attachmentGuid = ModalAttachment.Guid;
    }
    if (prevState.file !== "") {
      dispatch(postModalAttachment(prevState.file));
      prevState.file = "";
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Make And Model" });
  }

  UpdateMakeModel() {
    
    const { dispatch, match, t } = this.props;
    if (this.state.MakeModelDetails.make !== "" && this.state.models.length>0) {
      var modellist = this.state.models;
      let lookup = {
        lookUpToUpdate: "lookup",
        lookUpId: this.state.MakeModelDetails.makeId,
        lookUpType: "make",
        lookUpName: this.state.MakeModelDetails.make,
        modifiedBy: currentuser.name,
        intervalYear: 0,
        isDeleted: false,
        modelList: modellist,
        modelForDelete: this.state.DeleteModel,
      };
      let url = `${API.PostMakeModel}`;
      axios
        .put(url, lookup)
        .then((response) => {
          if (response.data) {
            let searchData = {
              Make: "",
              Model: "",
              PageNumber: 1,
              PageSize: 20,
            };
            if (fileDatas.length > 0) {
              this.props.dispatch(deleteAttachmentInBucket(fileDatas));
              fileDatas = [];
            }
            dispatch(getMakeSearchList(searchData));
            this.CancelEditMake();
            toast.success(`${t("CommonText.CommonUpdate")}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          dispatch({
            type: "putMakeModelDetailSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "putMakeModelDetailFailure",
            error: "ERROR",
          });
        });
    }
    else{
     if(this.state.MakeModelDetails.make==""){
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t('SwalError.EquipmentMake'),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
    })
  }
  else if( this.state.models.length==0){
    swal({
      title: t('SwalError.ErrorTitle'), 
      text: t('SwalError.EquipmentModel'),  
      icon: 'warning',  
      buttons: {
        confirm: {
          text: t('confirmAlertMessage.Ok')
        }
      }
  })
  }
    }
  }
  handleInputChange(e, field) {
    const nodeName = e.target.name;
    if (nodeName === "make") {
      this.state.MakeModelDetails.make = e.target.value;
      this.setState({});
    } else if (nodeName === "modelName") {
      this.state.ModelDetails[nodeName] = e.target.value;
      this.setState({})
    } else if (nodeName === "fileName") {
      let filename = e.target.files[0].name;
      this.setState({
        file: e.target.files[0],
        fileName: e.target.files[0].name,
      });
    }
  }
  ClearInput() {
    const { dispatch } = this.props;
    //this.props.dispatch(deleteAttachmentInBucket(this.state.ModelDetails.attachmentGuid,this.state.ModelDetails.attachmentName));


    const index = this.state.models.findIndex(
      attachment => this.state.fileName == attachment.attachmentName
    );

    let obj = {
      filename: index !== -1 ? this.state.models[index].attachmentName : "",
      guid: index !== -1 ? this.state.models[index].attachmentGuid : "",
    }
    fileDatas.push(obj);
    this.state.ModelDetails.attachmentName = "";
    this.state.ModelDetails.attachmentGuid = "";
    this.state.file = "";
    this.state.fileName = "";
    this.setState({}, () => {
      console.log(this.state.ModelDetails)
    });
    dispatch({ type: "postModalAttachmentUploadSuccess", data: "" });
  }
  showModal = (ModelId, isModelNew) => {
    var arrayStroage = this.state.models;
    var arrayLength = arrayStroage.length;
    if (ModelId > 0) {
      let response = this.state.models.filter(
        (item) => item.Id === ModelId || item.modelId === ModelId
      );
      let editModelDetails = response[0];
      this.setState(
        {
          modalIsOpen: !this.state.modalIsOpen,
          isModelNew: isModelNew,
          ModelDetails: {
            modelId: parseInt(editModelDetails.modelId),
            Id: editModelDetails?.Id,
            modelName: editModelDetails.modelName,
            attachmentName: editModelDetails.attachmentName,
            attachmentGuid: editModelDetails.attachmentGuid,
          },
          fileName: editModelDetails.attachmentName
        },
        () => console.log(this.state.isModelNew)
      );
    } else {
      fileDatas = [];
      this.setState(
        {
          isModelNew: isModelNew,
          ModelDetails: {
            Id: arrayLength >= 0 ? arrayLength + 1 : 0,
          },
          modalIsOpen: !this.state.modalIsOpen,
        },
        () => {
          console.log(this.state.ModelDetails.Id);
          fileDatas = [];
          this.ClearModel();
        }
      );
    }
  };

  ModelValidation = () => {
    var Model = this.state.ModelDetails.modelName;
    if (Model != "") {
      this.UploadModel();
    }
  };
  UploadModel = async () => {
    var product = {
      modelId: this.state.ModelDetails.modelId,
      Id: parseInt(this.state.ModelDetails.Id),
      modelName: this.state.ModelDetails.modelName,
      attachmentName: this.state.ModelDetails.attachmentName,
      attachmentGuid: this.state.ModelDetails.attachmentGuid,
    };
    let GetModel = this.state.models;
    let modelid = 0;
    GetModel.map((item) => {
      modelid = item.modelId;
    });
    if (product.modelId !== 0) {
      let temp =
        GetModel.filter((item) => item.modelId === product.modelId) || [];
      if (temp.length > 0) {
        GetModel.forEach((ele, index) => {
          if (ele.modelId === product.modelId) {
            GetModel[index] = product;
          }
        });
      } else {
        GetModel.push(product);
      }
    } else {
      let temp1 = GetModel.filter((item) => item.Id === product.Id) || [];
      if (temp1.length > 0) {
        GetModel.forEach((ele, index) => {
          if (ele.Id === product.Id) {
            GetModel[index] = product;
          }
        });
      } else {
        GetModel.push(product);
      }
    }
    localStorage.setItem("model", JSON.stringify(GetModel));
    var Information = JSON.parse(localStorage.getItem("model"));
    this.setState({ models: Information, modalIsOpen: false }, () => {
      if (this.state.isModelNew) {
        this.ClearModel();
      }
    });
  };
  ClearModel = () => {
    const { dispatch } = this.props;
    this.setState(
      {
        ModelDetails: {
          modelId: 0,
          Id: this.state.ModelDetails.Id,
          modelName: "",
          attachmentName: "",
          attachmentGuid: ""
        },
        file: "",
        fileName: "",
      },
      () => {
        console.log(this.state.ModelDetails);
      }
    );
    dispatch({ type: "postModalAttachmentUploadSuccess", data: "" });
  };
  deleteModel = (i) => {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const result1 = this.state.DeleteModel;
            const Models = [...this.state.models];
            const deleteId = this.state.models.filter(
              (k, index) => index === i
            );
            const modelid = deleteId ? deleteId[0]?.modelId : "";
            result1.push({ modelid });
            Models.splice(i, 1);
            this.setState({ models: Models });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { },
        },
      ],
    });
  };
  render() {
    const { t } = this.props;
    return (
      <div className="pb-3">
        <Modal
          size="lg"
          show={this.state.modalIsOpen}
          onHide={() => {
            this.showModal(0, true);
          }}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
          className="borderCondition"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "#1a3464", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">{t("ShipEquipmentStatusScreen.Model")}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className={"col-lg-6"}>
                <label className="form-label required">{t("ShipEquipmentStatusScreen.Model")}</label>
                <br></br>
                <input
                  className="form-control"
                  type="text"
                  name="modelName"
                  value={this.state.ModelDetails.modelName}
                  placeholder={t("ShipEquipmentStatusScreen.Model")}
                  onChange={(e) => this.handleInputChange(e)}
                ></input>
              </div>
              <div className="col-lg-6">
                <label className="form-label">{t("FlagScreen.Attachment")}</label>
                <br></br>
                <div class="input-group ">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      {t("CommonText.BrowseFile")}
                      <input
                        type="file"
                        id="files"
                        name="fileName"
                        style={{ marginRight: 40 }}
                        onChange={(e) => this.handleInputChange(e)}
                        onClick={(event) => {
                          event.currentTarget.value = null;
                        }}
                      />
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    placeholder={t("CommonText.Nofilechoosen")}
                    value={this.state.fileName}
                  />
                  {this.state.fileName ? (
                    <div
                      class="input-group-append"
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        class="fa fa-times input-group-text padding-top-9px"
                        aria-hidden="true"
                        onClick={() => this.ClearInput()}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 ml-auto">
                <div
                  className="search-btn-col pt-3"
                  style={{ textAlign: "end" }}
                >
                  <button
                    type="button"
                    id="SBMCAdd"
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-2"
                    style={{ backgroundColor: "rgb(26, 52, 100)" }}
                    onClick={() => this.ModelValidation()}
                  >
                    {this.state.isModelNew ? `${t("ShipManagementContent.Add")}` : `${t("EquipmentServiceTypes.Update")}`}
                  </button>
                  <button
                    type="button"
                    className="btn btn-light text-uppercase txtside-btn txtht-btn mt-2 ml-2"
                    data-dismiss="modal"
                    onClick={() => this.showModal(0, true)}
                  >
                    {t("ComplianceandBudgetScreen.Cancel")}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {this.renderCardData()}
      </div>
    );
  }

  renderCardData() {
    const { t } = this.props;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }} >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}>
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}>
                    {t("MakeAndModelScreen.EditMake")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-4">
                  <label className="form-label required">{t("ShipEquipmentStatusScreen.Make")}</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="make"
                    value={this.state.MakeModelDetails.make}
                    placeholder={t("ShipEquipmentStatusScreen.Make")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
              </div>

              <div className="search-filter-box">
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}>
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}>
                    <h6
                      className="card-title ml-2 mt-2 f2"
                      style={{ color: "092a51" }}
                    >
                      {t("ShipEquipmentStatusScreen.Model")}
                    </h6>
                    <div
                      className="m-1 flex"
                      onClick={() => this.showModal(0, true)}
                    >
                      <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                      <AddIcon />
                    </div>
                  </div>
                </div>
                <div className="search-filter-box">
                  {this.renderModelCard()}
                </div>
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.UpdateMakeModel()}
                    >
                      {" "}
                      {t("EquipmentServiceTypes.Update")}{" "}
                    </button>

                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.CancelEditMake()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderModelCard = () => {
    const { t } = this.props;
    const ModelArray = this.state.models;
    const isArabic = i18n.language === 'arab'
    return ModelArray && ModelArray.length ? (
      ModelArray.map((item, index) => {
        return (
          <div
            className="card click m-3"
            style={{
              backgroundColor: "#f0f0f0",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-9 col-md-10 col-9 m-auto">
                    <div className="row">
                      <div className="col-sm-6">
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ComplianceandBudgetScreen.ModelName")} </strong>
                          <strong>:</strong>

                        </span>
                        {item.modelName}
                      </div>
                      <div className={"col-sm-6"} >
                        <span>
                          <strong>{t("FlagScreen.Attachment")} : </strong>
                          <span className="italicFont ">
                            {item.attachmentName}{" "}
                          </span>
                          {item.attachmentName ? (
                            <i
                              className="fa fa-download click ml-1"
                              onClick={() =>
                                this.DownloadDoc(
                                  item.attachmentName,
                                  item.attachmentGuid
                                )
                              }
                              aria-hidden="true"
                              style={{
                                color: " #1a3464",
                                fontSize: "1.2rem",
                              }}
                            ></i>
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-3 col-3 m-auto">
                    <div className="text-right">
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderedit()}
                      >
                        <i
                          className="fa fa-edit fa-lg click m-1 px-1"
                          onClick={() =>
                            this.showModal(item.modelId || item.Id, false)
                          }
                          aria-hidden="true"
                          style={{ color: " #1a3464", fontSize: "1.8rem" }}
                        ></i>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderdelete()}
                      >
                        <i
                          className="fa fa-trash click m-1 px-2"
                          onClick={() => this.deleteModel(index)}
                          aria-hidden="true"
                          style={{ color: " #1a3464", fontSize: "1.8rem" }}
                        ></i>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div
        className="card m-3"
        style={{ overflow: "hidden", position: "relative" }}
      >
        <div class="container">
          <h6 className="resource-list-title no-item-card">
            !--{t("MakeAndModelScreen.NoItem")}--!
          </h6>
        </div>
      </div>
    );
  };
  DownloadDoc(attachmentName, attachmentGuid) {
    this.props.dispatch(DownloadAttachment(attachmentName, attachmentGuid));
  }

  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  CancelEditMake() {
    fileDatas = [];
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/LookupMakeAndModel");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    MakeDetail: state.MasterScreenReducer.MakeDetail,
    ModalAttachment: state.lookupReducer.ModalAttachment,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MakeEdit)));
